import React from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

class ScrollToTop extends React.Component {

  constructor(props) {
    super(props);
    this.state = { reload: false }
  }

  componentDidUpdate = (prevProps) => {

    //const { reload_page, location } = this.props;

    //if (prevProps.reload!==reload_page) return window.scrollTo(0,0);

    //if (prevProps.location !== location) return window.scrollTo(0, 0);

  }

  render() {
    return this.props.children
  }

}

const mapStateToProps = ({ cache }) => ({ reload: cache.reload_page });

export default connect(mapStateToProps,{})(withRouter(ScrollToTop));
